import About from '../screen/container/static-page/about';

export const aboutRoute = [
    {
      component: About,
      exact: true,
      path: "/about",
      guard: "public",
    },
  ];